import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconIncrement = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 32 32" size={size}>
      <g>
        <rect fill="none" height="32" width="32" />
      </g>
      <g>
        <polygon points="30,22 16.001,8 2.001,22  " />
      </g>
    </BaseIcon>
  );
}

export default IconIncrement;

